<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="visibility" style="display:block">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Оставить заявку</h5>
                    </div>
                    <div class="modal-body contact-form">
                        <div class="row">
                          <div class="col-md-6 form-group">
                            <label for="exampleInputName2">Имя<span style="color:red;font-size:larger">*</span></label>
                            <input type="text" class="form-control" id="exampleInputName2" placeholder="Введите Ваше имя" v-model="feedbackName">
                          </div>
                          <div class="col-md-6 form-group">
                            <label for="exampleInputEmail2">Контактный телефон<span style="color:red;font-size:larger">*</span></label>
                            <input type="phone" class="form-control" id="exampleInputEmail2" placeholder="Введите телефон для связи" v-model="feedbackPhone">
                          </div>
                          <div class="col-md-12 form-group">
                            <div style="padding-top: 0px">
                              <img :src="captchaUrl" style="border: 1px solid #30ade7;border-style:dashed;border-radius:3px">
                              <i class="fa fa-refresh"
                                 style="color:#30ade7;font-size:28px;padding:10px;top:6px;position:relative;cursor:pointer"
                                 @click="reloadCaptcha"
                              ></i>
                              <input type="text" class="" v-model="captchaCode" placeholder="Введите код с картинки">
                            </div>
                            <input type="button" class="btn-form uppercase border-radius" value="Отправить" @click.prevent="send" style="margin-top: 5px">
                            &nbsp;
                            <input type="button" class="btn-form uppercase border-radius btn-secondary uppercase clear-choose" data-dismiss="modal" @click="clearChoose" value="Закрыть">
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <alert :visibility="alertShow" :message="alertMessage" @closeDialog="closeDialog"/>
    </div>
</template>

<script>
  import Alert from './Alert.vue'
  export default {
    name: "SubmitApp",
    components: { Alert },
    props: ["visibility","message"],
    data () {
      return {
        alertShow: false,
        alertMessage: '',
        feedbackName:'',
        feedbackPhone:'',
        captchaUrl: process.env.VUE_APP_POINT_API + '/captcha',
        formidentyfic:'',
        captchaCode:''
      }
    },

    created() {
      this.formidentyfic = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 12)
      this.reloadCaptcha()
    },

    methods:{
      reloadCaptcha() {
        // обновляем капчу на сервере
        this.axios.get(process.env.VUE_APP_POINT_API + '/captcha?refresh=true&formidentyfic='+this.formidentyfic)
        .then((res) => {
          // подгружаем ее как картинку
          this.captchaUrl = process.env.VUE_APP_POINT_API + res.data.url + '&formidentyfic=' +this.formidentyfic
        })
      },
      checkRequired() {
        return !(!this.feedbackName || !this.feedbackPhone);
      },
      clearFormAndReloadCaptcha() {
        this.feedbackName = ''
        this.feedbackPhone = ''
        this.captchaCode = ''
        this.reloadCaptcha();
      },
      send() {
        if (!this.checkRequired()) {
          this.alertMessage = "Все поля формы обязательны для заполнения!"
          this.alertShow = true
          return
        }
        if (!this.captchaCode) {
          this.alertMessage = "Введите код проверки Капчи!"
          this.alertShow = true
          return
        }

        // проверяем капчу на сервере
        this.axios.get(process.env.VUE_APP_POINT_API + '/captcha?validateval='+this.captchaCode+'&formidentyfic='+this.formidentyfic)
        .then((res) => {
          // отправляем форму обратной связи
          if (!res.data.isvalid) {
            this.alertMessage = "Неверно введен код Капчи!"
            this.alertShow = true
            this.captchaCode = ''
            this.reloadCaptcha()
            return
          }
          this.axios.post(
            process.env.VUE_APP_POINT_API + '/submit-app',
            {name:this.feedbackName, phone:this.feedbackPhone},
          )
          .then(() => {
            this.alertMessage = "Спасибо за обращение! Наш менеджер свяжется с вами в ближайшее время"
            this.alertShow = true
            this.clearFormAndReloadCaptcha()
            this.$emit("closeDialog", false)
            window.dataLayer.push({'event': 'send-order-form'})
          })
          .catch(() => {
            this.alertMessage = "К сожалению возникла непредвиденная ошибка! Попробуйте отправить сообщение позже! Спасибо за понимание!"
            this.alertShow = true
            this.clearFormAndReloadCaptcha();
          })
        })
        .catch(() => {
          this.alertMessage = "К сожалению возникла непредвиденная ошибка! Попробуйте отправить сообщение позже! Спасибо за понимание!"
          this.alertShow = true
          this.clearFormAndReloadCaptcha();
        })

      },
      closeDialog() {
        this.alertShow = false
      },
      clearChoose() {
        this.$emit("closeDialog", false)
      },
    }
  }
</script>

<style scoped>
    .clear-choose {
        background: #44cc12;
        color: white;
    }
    .modal-header {
       background: #30ade7;
       color: white;
       text-transform: uppercase;
    }
    .modal-header h5{
        font-weight: bold;
    }
</style>
